__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/0c740d9/_next/";